import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { GlobalSpinnerService } from '../../../shared/components/loader-service/global-spinner.service';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { BridgeAdUnit } from '../../../shared/domain/bridge-ad-unit.model';
import { DpSiteDetailsDialogComponent } from '../../shared/components/kn-dp-site-details-dialog.component';
import { Domain } from '../../../shared/domain/domain.model';
import { DomainDpStatus } from '../../../shared/domain/domain-dp-approval.model';
import { SortUtils } from '../../../shared/utils/sort-utils';

@Component({
  selector: 'cm-ad-unit-domains-list-dialog',
  template: `
    <h3 mat-dialog-title>
      <strong>{{unit.name}}</strong>
    </h3>
    <mat-dialog-content class="p-0">
      <mat-divider></mat-divider>
      <table class="mat-table w-100">
        <tr *ngFor="let d of unit.domains" class="mat-row">
          <td class="mat-cell link" (click)="openPartnersDetails(d)"
              [ngClass]="{
            'text-danger': d._dpApprovalsMap && d._dpApprovalsMap[data.demandPartner] === DomainDpStatus.REJECTED,
            'text-success': d._dpApprovalsMap && d._dpApprovalsMap[data.demandPartner] === DomainDpStatus.APPROVED
              }"
          >{{d.url}}
          </td>
          <td class="mat-cell">
            <cm-adstxt-status-details [domain]="d"></cm-adstxt-status-details>
          </td>
        </tr>
      </table>
    </mat-dialog-content>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
    </div>`,
  styles: [`
    td.mat-cell, td.mat-footer-cell, th.mat-header-cell {
      border-bottom: none;
    }
  `]
})
export class AdUnitDomainListDialogComponent {
  unit: BridgeAdUnit;

  DomainDpStatus = DomainDpStatus;

  constructor(public dialogRef: MatDialogRef<AdUnitDomainListDialogComponent>,
              private gss: GlobalSpinnerService,
              private sbs: SnackBarService,
              private matDialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: { unit: BridgeAdUnit, demandPartner: string, dpSitesSubmittedColumnVisible?: boolean }) {
    this.unit = data.unit;
    if (this.unit.domains) {
      this.unit.domains.sort(SortUtils.propertyComparatorString('url'));
    }
    if (data.demandPartner) {
      this.unit.domains.forEach(d => {
        if (this.unit.siteApprovals.siteDpApprovals[d.url]) {
          d.dpApprovals = this.unit.siteApprovals.siteDpApprovals[d.url];
          d._dpApprovalsMap = d.dpApprovals.reduce((prev, curr) => {
            prev[curr.id.demandPartner] = curr.status;
            return prev;
          }, {});
        }
      });
    }
  }


  openPartnersDetails(domain: Domain) {
    if (this.unit.siteApprovals.siteDpApprovals[domain.url]) {
      domain.dpApprovals = this.unit.siteApprovals.siteDpApprovals[domain.url];
      domain.dpsApprovedCount = domain.dpApprovals.filter(d => d.status === DomainDpStatus.APPROVED).length;
      domain.dpsCount = domain.dpApprovals.length;
    }
    this.matDialog.open(DpSiteDetailsDialogComponent, <MatDialogConfig>{
      data: {
        domain: domain,
        submittedVisible: this.data.dpSitesSubmittedColumnVisible
      },
      width: '600px'
    });
  }

}
